// theme.js
import { createTheme } from '@mui/material/styles';

const baseTheme = {
    typography: {
        fontWeight: '600',
        h1: {
            fontWeight: 'bold'
        },
        h2: {
            fontWeight: '600'
        },
        h3: {
            fontWeight: '500'
        },
        h4: {
            fontWeight: '500'
        },
        h5: {
            fontWeight: '500'
        },
        h6: {
            fontWeight: '400'
        },
    },
};

const lightPalette = {
    mode: 'light',
    primary: {
        main: "#96B43C",
        text: "#fff",
        bold: "#000",
    },
    secondary: {
        main: "#6A1808",
        text: "#A4A9A6",
    },
    nav: {
        main: "#fff", //#96B43C",
        link: '#000',
        hover: '#96B43C'
    },
    footer: {
        main: "#96B43C",
        link: '#fff',
        hover: '#A69F9F'
    },
    background: {
        default: "#fff",
        section: "#f7f7f7",
        card: '#fff',
        input: "#F5F5F5",
        form: "#fff",
        drawer: ''
    },
};

const getPalette = (mode) => (lightPalette);

const theme = (mode) => createTheme({ ...baseTheme, palette: getPalette(mode) });

export default theme;
